import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";
import { EstabelecimentosAtivosService } from "./modules/registers/estabelecimentos/services/estabelecimentos-ativos.service";
import { LookupModel } from "./shared/models";
import { EncripterService } from "./shared/services";
import { environment } from "environments";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, TranslocoModule],
})
export class AppComponent implements OnInit {
  private empresaAtivaService: EstabelecimentosAtivosService;
  private _encriptor: EncripterService;

  constructor() {
    this.empresaAtivaService = inject(EstabelecimentosAtivosService);
    this._encriptor = inject(EncripterService);
  }

  ngOnInit(): void {
    const empresaAtiva = this.getActive();

    if (empresaAtiva) {
      document.title = `${environment.appName} - ${empresaAtiva.description}`;
    } else {
      document.title = `${environment.appName}`;
    }
  }

  getActive(): LookupModel {
    const plain = localStorage.getItem("activeEstabelecimento") ?? "";
    if (!plain) {
      return null;
    }

    try {
      return JSON.parse(this._encriptor.get(null, plain));
    } catch (e) {
      return null;
    }
  }
}
